/**
 * Position newsletter card as last item in first row
 * This script calculates the grid layout and moves the newsletter card
 * to be positioned at the end of the first row of cards
 */

/**
 * Position newsletter card as last item in first row
 * This script calculates the grid layout and moves the newsletter card
 * to be positioned at the end of the first row of cards
 *
 * Note: For AJAX requests, the position is calculated and sent to server.
 * This script only handles initial page load and window resize.
 */

(function ($) {
	async function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	async function positionCard() {
		const $listing = $('#listing');

		if (!$listing.length) return;

		// On live-search pages, stuck-card.js is loaded and exposes
		// window.repositionStuckCard — use it, as it is filtering-aware.
		if (typeof window.repositionStuckCard === 'function') {
			window.repositionStuckCard($listing[0]);
			return;
		}

		// Fallback for pages without stuck-card.js (regular archives, no live filtering)
		const cardClassName = '.last-for-first-row';
		const $cardToPlace = $listing.find(cardClassName);

		if (!$cardToPlace.length) {
			return;
		}

		// Get all card containers except the newsletter card
		const $allCards = $listing.find('.item-card-container');
		const $regularCards = $allCards.not(cardClassName);

		if (!$regularCards.length) {
			// No regular cards, just keep newsletter at start
			return;
		}

		// IMPORTANT: Remove the newsletter card from the DOM first
		// so it doesn't affect the Y coordinates of other cards
		$cardToPlace.detach();

		// Now get the Y position of the first card to establish the first row
		const firstCardTop = $regularCards.eq(0).offset().top;

		// Find all cards in the first row by comparing their Y positions
		const firstRowCards = $regularCards.filter(function () {
			const cardTop = $(this).offset().top;
			// Allow small tolerance (5px) for subpixel rendering differences
			return Math.abs(cardTop - firstCardTop) < 5;
		});

		// If the first card is a sticky card (spans the full first row), target the
		// second row instead so the stuck card lands last in row 2, not row 1.
		let targetRowCards = firstRowCards;
		const firstCardIsStickyFullRow =
			firstRowCards.length === 1 && $regularCards.eq(0).find('.item-card--sticky').length > 0;

		if (firstCardIsStickyFullRow && $regularCards.length > 1) {
			const secondCardTop = $regularCards.eq(1).offset().top;
			const secondRowCards = $regularCards.filter(function (i) {
				return i > 0 && Math.abs($(this).offset().top - secondCardTop) < 5;
			});
			if (secondRowCards.length) {
				targetRowCards = secondRowCards;
			}
		}

		// Determine how many columns the grid has from computed style
		const gridCols = getComputedStyle($listing[0]).gridTemplateColumns;
		const columnCount = gridCols.split(' ').filter((s) => s.trim().length > 0).length;

		// Only insert before the last card if the target row is full (last slot is occupied),
		// which would push that card to the next row to make room for the stuck card.
		// If the row isn't full, just append after the last card — it fits without wrapping.
		if (targetRowCards.length >= columnCount) {
			$cardToPlace.insertBefore(targetRowCards.last());
		} else {
			targetRowCards.last().after($cardToPlace);
		}
	}

	// Debounce function for resize
	function debounce(callback, wait = 300) {
		let timeout = null;
		return function () {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				callback.apply(this, arguments);
			}, wait);
		};
	}

	// Run on page load (for initial render and direct page loads)
	$(document).ready(positionCard);

	// Run on window resize (debounced)
	// AJAX loads are handled server-side with newsletter_pos parameter
	$(window).on('resize', debounce(positionCard, 50));
})(jQuery);
